// Footer.jsx — pie de página con enlaces de campaña, contacto y redes.

import React from 'react'
import { LogoCbqImg } from '../CampaignMediaImg.jsx'

function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-cols">
          <div>
            <a className="brand" href="#top" style={{ marginBottom: 20 }}>
              <span className="brand-mark">
                <LogoCbqImg alt="" />
              </span>
              <span className="brand-text">
                Bomberos Quilpué
                <small>Desde 1925</small>
              </span>
            </a>
            <p style={{ color: "var(--fg-mute)", fontSize: 13.5, lineHeight: 1.6, maxWidth: 32 + "ch", marginTop: 20 }}>
              Cuerpo de Bomberos de Quilpué. Voluntarios al servicio de la comunidad desde 1925.
              5 compañías más una brigada en formación: <b>una sola misión</b>.
            </p>
          </div>
          <div>
            <h4>Campaña</h4>
            <ul>
              <li><a href="#por-que">¿Por qué importa?</a></li>
              <li><a href="#como">Cómo donar</a></li>
              <li><a href="#en-vivo">Donaciones en el feed</a></li>
              <li><a href="#faq">Preguntas frecuentes</a></li>
            </ul>
          </div>
          <div>
            <h4>Contacto</h4>
            <ul>
              <li style={{ color: "var(--fg-mute)", fontSize: 13.5 }}>donaciones@bomberosquilpue.cl</li>
              <li style={{ color: "var(--fg-mute)", fontSize: 13.5 }}>+56 32 291 3460 (Horario de Atención Lun. a Vie. 10:00 a 17:00 hrs., excepto festivos). <b>Para Emergencias marca el 132</b></li>
              <li style={{ color: "var(--fg-mute)", fontSize: 13.5 }}>Cuartel General</li>
              <li style={{ color: "var(--fg-mute)", fontSize: 13.5 }}>Bulnes 1029, Quilpué</li>
              <li style={{ color: "var(--fg-mute)", fontSize: 13.5 }}>Región de Valparaíso</li>
            </ul>
          </div>
          <div>
            <h4>Síguenos</h4>
            <ul>
              <li><a href="https://www.instagram.com/bomberosquilpue" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://www.facebook.com/CBQuilpue/" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="https://x.com/CBQuilpue" target="_blank" rel="noopener noreferrer">X (Twitter)</a></li>
              <li><a href="https://www.tiktok.com/@bomberosquilpue" target="_blank" rel="noopener noreferrer">TikTok</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-base">
          <div>© 2026 Cuerpo de Bomberos de Quilpué · Personalidad jurídica vigente</div>
          <div>Sitio mantenido por el equipo de campaña #MecanicaParaQuilpue</div>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
